export const getURLWithOnlySearchParams = ({ url, searchParams = [] }: { url: URL, searchParams?: string[] }) => {
  const { origin, pathname, searchParams: originSearchParams } = url
  const newURL = new URL(`${origin}${pathname}`)

  searchParams.forEach((searchParam) => {
    const originSearchParam = originSearchParams.get(searchParam)
    if (originSearchParam) {
      newURL.searchParams.set(searchParam, originSearchParam)
    }
  })

  return newURL
}
